// Almacenamiento local de «Mi día» (949): IndexedDB, no localStorage — la cola
// lleva fotos de averías y localStorage se llena con pocas. Guarda:
//   · la última copia de «Mi día» por camarera (para verla sin señal), y
//   · la cola de cambios pendientes (eventos y averías) con su client_uuid.
// Si IndexedDB no está disponible (navegación privada), todo sigue funcionando
// en línea: las funciones fallan en silencio.
const DB = 'hotel-hk';
let dbp: Promise<IDBDatabase> | null = null;

function db(): Promise<IDBDatabase> {
  if (!dbp) {
    dbp = new Promise((res, rej) => {
      const req = indexedDB.open(DB, 1);
      req.onupgradeneeded = () => { req.result.createObjectStore('kv'); };
      req.onsuccess = () => res(req.result);
      req.onerror = () => rej(req.error);
    });
    dbp.catch(() => { dbp = null; });
  }
  return dbp;
}

export async function hkGet<T>(k: string): Promise<T | undefined> {
  try {
    const d = await db();
    return await new Promise((res, rej) => {
      const r = d.transaction('kv').objectStore('kv').get(k);
      r.onsuccess = () => res(r.result as T | undefined); r.onerror = () => rej(r.error);
    });
  } catch { return undefined; }
}

export async function hkSet(k: string, v: unknown): Promise<void> {
  try {
    const d = await db();
    await new Promise<void>((res, rej) => {
      const t = d.transaction('kv', 'readwrite');
      if (v === undefined || v === null) t.objectStore('kv').delete(k); else t.objectStore('kv').put(v, k);
      t.oncomplete = () => res(); t.onerror = () => rej(t.error);
    });
  } catch { /* sin almacenamiento local */ }
}

// Foto del celular → JPEG de hasta 1280 px (≈150-300 KB) en data URL.
export async function comprimirFoto(file: File, max = 1280, calidad = 0.6): Promise<string> {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise<HTMLImageElement>((res, rej) => {
      const i = new Image(); i.onload = () => res(i); i.onerror = () => rej(new Error('No se pudo leer la foto')); i.src = url;
    });
    const k = Math.min(1, max / Math.max(img.width, img.height));
    const c = document.createElement('canvas');
    c.width = Math.round(img.width * k); c.height = Math.round(img.height * k);
    c.getContext('2d')?.drawImage(img, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', calidad);
  } finally {
    URL.revokeObjectURL(url);
  }
}
